var _excluded = ["deviceMemory"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Config from '../config';
import { toHref, getParam, isLogin, getPUBK, accestokenByCode, getUserInfo, deleteToken as _deleteToken } from '../utils';
var Auth = /*#__PURE__*/function () {
  function Auth() {
    _classCallCheck(this, Auth);
    this.data = {
      authUrl: '',
      mode: '',
      authLoginType: '',
      pathname: window.location.pathname,
      onFinish: function onFinish(url) {}
    };
  }
  return _createClass(Auth, [{
    key: "isNoLogin",
    value: function isNoLogin() {
      return getParam('code') && !isLogin();
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
        var userInfo;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              window.sessionStorage.removeItem('noclose');
              this.data.authUrl = params.path;
              this.data.mode = params.mode || '';
              this.data.authLoginType = params.authLoginType || '';
              if (params === null || params === void 0 ? void 0 : params.onFinish) {
                this.data.onFinish = params.onFinish;
              }
              _context.next = 7;
              return this.initUserInfo(params);
            case 7:
              userInfo = _context.sent;
              return _context.abrupt("return", userInfo);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "logout",
    value: function logout(e, s, msg, userId) {
      window.sessionStorage.setItem('noclose', 'noclose');
      this.deleteToken(e, s, msg, userId);
    }
  }, {
    key: "getVisitorId",
    value: function () {
      var _getVisitorId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var fpPromise, fp, result, _result$components, deviceMemory, components, visitorId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fpPromise = FingerprintJS.load();
              _context2.next = 3;
              return fpPromise;
            case 3:
              fp = _context2.sent;
              _context2.next = 6;
              return fp.get();
            case 6:
              result = _context2.sent;
              _result$components = result.components, deviceMemory = _result$components.deviceMemory, components = _objectWithoutProperties(_result$components, _excluded);
              visitorId = FingerprintJS.hashComponents(components);
              localStorage.setItem('fp', visitorId);
              return _context2.abrupt("return", visitorId);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getVisitorId() {
        return _getVisitorId.apply(this, arguments);
      }
      return getVisitorId;
    }()
  }, {
    key: "initUserInfo",
    value: function () {
      var _initUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
        var userInfo;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (localStorage.getItem('fp')) {
                _context3.next = 9;
                break;
              }
              _context3.next = 3;
              return this.getVisitorId();
            case 3:
              _context3.next = 5;
              return this.authlogin(params);
            case 5:
              userInfo = _context3.sent;
              return _context3.abrupt("return", userInfo);
            case 9:
              _context3.next = 11;
              return this.authlogin(params);
            case 11:
              return _context3.abrupt("return", _context3.sent);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initUserInfo(_x2) {
        return _initUserInfo.apply(this, arguments);
      }
      return initUserInfo;
    }()
  }, {
    key: "getAccessUser",
    value: function () {
      var _getAccessUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(accessToken) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              sessionStorage.setItem('ACCESS_TOKEN', accessToken);
              // 解析token获取用户信息
              return _context4.abrupt("return", toHref(accessToken));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function getAccessUser(_x3) {
        return _getAccessUser.apply(this, arguments);
      }
      return getAccessUser;
    }()
  }, {
    key: "getUserInfoFormCode",
    value: function () {
      var _getUserInfoFormCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params) {
        var code, basicSecret;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              code = getParam('code');
              _context5.next = 3;
              return getPUBK(params.mode, params.authLoginType);
            case 3:
              basicSecret = _context5.sent;
              _context5.next = 6;
              return accestokenByCode(params, code, basicSecret);
            case 6:
              return _context5.abrupt("return", _context5.sent);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function getUserInfoFormCode(_x4) {
        return _getUserInfoFormCode.apply(this, arguments);
      }
      return getUserInfoFormCode;
    }()
  }, {
    key: "replaceUrl",
    value: function replaceUrl() {
      var url = window.location.href;
      var state = getParam('state');
      if (url.indexOf('?') != -1) {
        //判断是否存在参数
        url = url.replace(/(\?|#)[^'"]*/, ''); //去除参数
      }
      if (state && this.data.onFinish) {
        this.data.onFinish(decodeURIComponent(state));
      } else {
        window.history.pushState(null, '', url);
      }
    }
  }, {
    key: "authlogin",
    value: function () {
      var _authlogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params) {
        var _this = this;
        var isRepalceUrl;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              isRepalceUrl = false;
              return _context6.abrupt("return", new Promise(function (resolve, reject) {
                /**
                 * 登录和白名单
                 */
                if (isLogin() || params.allow && params.allow.includes(_this.data.pathname)) {
                  resolve(getUserInfo());
                  return;
                }
                /**
                 * 有accessToken
                 */
                var accessToken = getParam('access_token') || getParam('ACCESS_TOKEN');
                if (accessToken) {
                  resolve(_this.getAccessUser(accessToken));
                  return;
                }
                /**
                 * 没有登录
                 */
                if (_this.isNoLogin()) {
                  isRepalceUrl = true;
                  resolve(_this.getUserInfoFormCode(params));
                  return;
                }
                /**
                 * 退出登录
                 */
                if (getParam('logout') === 'yes') {
                  _this.deleteToken();
                  resolve(undefined);
                  return;
                }
                /**
                 * 其他情况
                 */
                if (Config.grant_type === 'authorization_code') {
                  resolve(undefined);
                  var urlHost = '';
                  urlHost = params.urlHref || Config.baseUrl;
                  var state = params.search ? "&state=".concat(encodeURIComponent(params.search)) : '';
                  window.location.href = params.path + '/oauth/authorize?response_type=code&client_id=' + Config.appId + '&redirect_uri=' + urlHost + state;
                  return;
                }
              }).finally(function () {
                if (isRepalceUrl) {
                  _this.replaceUrl();
                }
              }));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function authlogin(_x5) {
        return _authlogin.apply(this, arguments);
      }
      return authlogin;
    }() // msg 0 或者不传是发消息登出，其他值不发消息，-99 修改密码所有端登出
  }, {
    key: "deleteToken",
    value: function deleteToken(e, s, msg, uId) {
      _deleteToken(this.data.authUrl, e, s, msg, uId);
    }
  }]);
}(); // 新版本引入方式
export var auth = new Auth();
// 兼容老版本引入方式
export var Thing = function Thing() {
  console.log('new Thing()');
  return auth;
};